var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSleepy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "480.83px",
    height: "347.04px",
    viewBox: "0 0 480.83 347.04",
    enableBackground: "new 0 0 480.83 347.04",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CDDFE3",
    d: "M183.31,43.16C54.29,93.56-30.92,198.71,16.36,279.51s172.93,73.22,288.1,33.98 c79.78-27.18,168.23-98.85,169.74-149.7c0.66-22.31-17.44-34.07-27.68-54.94C429.79,74.74,426.85-51.99,183.31,43.16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#868B90",
    d: "M208.88,69.75c-96.6,36.92-160.39,113.93-125,173.11s129.47,53.63,215.7,24.89 c59.73-19.91,125.95-72.4,127.08-109.65c0.5-16.34-13.06-24.95-20.72-40.24C393.41,92.88,391.22,0.06,208.88,69.75z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 250.3352,
    cy: 166.4869,
    r: 232.0094,
    gradientTransform: "matrix(0.9181 -0.3964 0.1961 0.4543 -12.1495 190.0781)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B8BCBE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    style: {
      stopColor: "#BBBFC1",
      stopOpacity: 0.278
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BEC2C5",
      stopOpacity: 0
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M208.88,69.75c-96.6,36.92-160.39,113.93-125,173.11s129.47,53.63,215.7,24.89 c59.73-19.91,125.95-72.4,127.08-109.65c0.5-16.34-13.06-24.95-20.72-40.24C393.41,92.88,391.22,0.06,208.88,69.75z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_2_",
    cx: 252.8075,
    cy: 170.5241,
    r: 173.6497,
    gradientTransform: "matrix(0.9444 -0.3287 0.1836 0.5276 -17.264 163.6505)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DCE1E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#DDE2E6",
      stopOpacity: 0
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M208.88,69.75c-96.6,36.92-160.39,113.93-125,173.11s129.47,53.63,215.7,24.89 c59.73-19.91,125.95-72.4,127.08-109.65c0.5-16.34-13.06-24.95-20.72-40.24C393.41,92.88,391.22,0.06,208.88,69.75z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 480.362,
    y1: 94.801,
    x2: 375.1805,
    y2: 129.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#868A8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#868B92",
      stopOpacity: 0
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M208.88,69.75c-96.6,36.92-160.39,113.93-125,173.11s129.47,53.63,215.7,24.89 c59.73-19.91,125.95-72.4,127.08-109.65c0.5-16.34-13.06-24.95-20.72-40.24C393.41,92.88,391.22,0.06,208.88,69.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M204.31,182.83l-64.57,29.89c-5.78,2.68-12.64,0.16-15.32-5.62l0,0c-2.68-5.78-0.16-12.64,5.62-15.32 l64.57-29.89c5.78-2.68,12.64-0.16,15.32,5.62v0C212.61,173.3,210.1,180.16,204.31,182.83z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M182.59,192.89l-33.3,15.42c-5.78,2.68-12.64,0.16-15.32-5.62v0c-2.68-5.78-0.16-12.64,5.62-15.32 l33.3-15.42c5.78-2.68,12.64-0.16,15.32,5.62l0,0C190.89,183.36,188.37,190.21,182.59,192.89z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M173.71,197l-18.59,8.61c-5.78,2.68-12.64,0.16-15.32-5.62l0,0c-2.68-5.78-0.16-12.64,5.62-15.32 l18.59-8.61c5.78-2.68,12.64-0.16,15.32,5.62l0,0C182.01,187.47,179.49,194.32,173.71,197z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M364.74,106.25l-61.18,28.32c-5.78,2.68-12.64,0.16-15.32-5.62l0,0c-2.68-5.78-0.16-12.64,5.62-15.32 l61.18-28.32c5.78-2.68,12.64-0.16,15.32,5.62v0C373.04,96.71,370.53,103.57,364.74,106.25z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.0499,
    y1: 209.672,
    x2: 262.2128,
    y2: 184.5027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#404749"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    style: {
      stopColor: "#313537"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#181818"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M284.19,179.5c6.78,4.4,7.23,15.74,1,25.32s-16.76,13.77-23.54,9.37c-6.78-4.4-7.23-15.74-1-25.32 S277.41,175.1,284.19,179.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B2226",
    d: "M339.85,117.77l-26.99,12.49c-5.78,2.68-12.64,0.16-15.32-5.62v0c-2.68-5.78-0.16-12.64,5.62-15.32 l26.99-12.49c5.78-2.68,12.64-0.16,15.32,5.62v0C348.15,108.24,345.63,115.1,339.85,117.77z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A373F",
    d: "M332.66,121.1l-15.51,7.18c-5.78,2.68-12.64,0.16-15.32-5.62l0,0c-2.68-5.78-0.16-12.64,5.62-15.32 l15.51-7.18c5.78-2.68,12.64-0.16,15.32,5.62v0C340.96,111.57,338.44,118.42,332.66,121.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepy);
export default __webpack_public_path__ + "static/media/sleepy.aae3acd10502a3d66c9153d4a4496745.svg";
export { ForwardRef as ReactComponent };